export const includedInArray = (array, elementFind) =>
  array.includes(elementFind);

export const positionInTheArray = (array, elementFind) =>
  array.indexOf(elementFind);
